import { useNavigation } from '@react-navigation/native'
import { Icon } from '@rneui/themed'
import PropTypes from 'prop-types'
import React from 'react'
import { Dimensions, Modal, StyleSheet, TouchableWithoutFeedback, View } from 'react-native'

import DualButton from '@src/components/DualButton'
import Text from '@src/components/Text'
import { colors, fonts } from '@src/config/theme'

const { height, width } = Dimensions.get('screen')

const AddGroupPopup = ({ visible, onClose }) => {
  const navigation = useNavigation()

  return (
    <Modal transparent visible={visible} animationType="none" onRequestClose={onClose}>
      <TouchableWithoutFeedback onPress={onClose}>
        <View style={{ ...StyleSheet.absoluteFill, ...styles.container }}>
          <TouchableWithoutFeedback>
            <View style={styles.content}>
              <View style={styles.icon}>
                <Icon color={colors.secondary} size={24} type="feather" name="users" />
              </View>
              <View style={styles.texts}>
                <Text style={styles.title}>Create a group first</Text>
                <Text style={styles.comment}>
                  All sessions have to be assigned to a group and it seems like you haven't created
                  one yet, so let's do that first, shall we?
                </Text>
              </View>

              <View style={styles.buttons}>
                <DualButton
                  leftTitle="Back"
                  rightTitle="Create"
                  leftOnPress={onClose}
                  rightOnPress={() => {
                    onClose()
                    navigation.navigate('SelectGroupScreen')
                  }}
                />
              </View>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  )
}

const buttonWidth = (width * 0.8 - 40 - 10) / 2

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#1119',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    width: '80%',
    borderRadius: 6,
    padding: 20,
    shadowOffset: { width: 2, height: 2 },
    shadowColor: 'black',
    shadowOpacity: 0.2,
    backgroundColor: colors.white,
    marginTop: height / 5,
    alignItems: 'center',
  },
  texts: {
    paddingHorizontal: 10,
    alignItems: 'center',
  },
  icon: {
    marginVertical: 20,
    width: 80,
    height: 80,
    borderWidth: 1,
    borderColor: colors.secondary,
    borderRadius: 50,
    justifyContent: 'center',
  },
  percentText: {
    position: 'absolute',
    top: 0,
    fontFamily: fonts.default.bold,
  },
  title: {
    color: colors.secondary,
    fontSize: 13,
    textTransform: 'uppercase',
    // fontWeight: 'bold',
    fontFamily: fonts.default.bold,
    textAlign: 'center',
  },
  comment: {
    margin: 10,
    color: colors.secondary,
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 15,
    lineHeight: 17,
  },
  gradientButtonStyle: {
    borderRadius: 23,
    height: 42,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 0,
  },

  gradientButtonContainer: {
    height: 42,
    width: '80%',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  gradientButtonText: {
    fontSize: 12,
    fontFamily: fonts.default.semiBold,
  },
  buttonContainer: {
    borderRadius: 23,
    height: 35,
    justifyContent: 'center',
    alignItems: 'center',
    width: buttonWidth,
    marginRight: 10,
  },
  button: { width: '45%' },
  gradientButton: { width: '45%' },
  buttons: {
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 20,
  },
})

AddGroupPopup.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default AddGroupPopup
